import {DEFAULT_TIME_ZONE} from "../../constants";
import React from "react";

export const defaultState = {
    userTimezone: global.props?.user?.timezone || DEFAULT_TIME_ZONE,
};

export const AnonymousUserContext = React.createContext();

export const AnonymousUserProvider = ({ children }) => {
  return (
    <AnonymousUserContext.Provider value={defaultState}>
      {children}
    </AnonymousUserContext.Provider>
  );
}
